import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportService } from '../../../../../common/services/Report.service';
import { THROW_IF_NOT_FOUND } from '@angular/core/src/di/injector';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import * as _ from 'lodash';

declare var $: any;
declare var Chartist: any;

@Component({
  selector: 'report-summary',
  templateUrl: './summary.template.html',
  styleUrls: ['../report.component.css'],
  providers: [ReportService],
})
export class SummaryComponent implements OnInit {
  public options: any;
  public modelFilter: any = {};
  public analytic_type = 'source';
  public analytic_contact_type = 'source';
  public options_ticket: any = {};
  public options_contact: any = {};
  public ticketType: Array<any> = [];
  public contactType: Array<any> = [];
  public chart_type = 'pie';
  public chart_contact_type = 'column';
  public layout = 'summary';

  constructor(private reportService: ReportService) {
    this.modelFilter = {
      from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
      to: moment().format('YYYY-MM-DD HH:mm'),
    };
  }

  ngOnInit() {
    this.ticketType = [
      {
        id: 'source',
        text: 'Nguồn',
      },
      {
        id: 'status',
        text: 'Trạng thái',
      },
      {
        id: 'priority',
        text: 'Ưu tiên',
      },
      {
        id: 'service',
        text: 'Dịch vụ',
      },
      {
        id: 'type',
        text: 'Phân loại',
      },
    ];

    this.contactType = [
      {
        id: 'source',
        text: 'Nguồn',
      },
      {
        id: 'sex',
        text: 'Giới tính',
      },
      {
        id: 'city',
        text: 'Thành phố',
      },
    ];
    this.layout = 'summary';
    this.loadTicketSummary();
    this.loadContactSummary();
  }
  // ngAfterViewInit() {
  // $('.3csoft-datepicker').datepicker({ format: 'YYYY-MM-DD HH:mm' });
  // $('.3csoft-datepicker').datepicker({ format: 'YYYY-MM-DD HH:mm' });
  // }

  loadTicketSummary() {
    this.reportService
      .reportTicketSummary({
        type: this.analytic_type,
        from: this.modelFilter.from,
        to: this.modelFilter.to,
      })
      .subscribe(res => {
        const data = _.map(res.data.tickets, e => {
          if (this.chart_type == 'pie') {
            return {
              name: e.title + ': ' + e.count,
              y: e.count,
            };
          } else {
            return [e.title, e.count];
          }
        });
        this.options_ticket = {
          xAxis: {
            type: 'category',
            labels: {
              rotation: -45,
              style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif',
              },
            },
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Tổng ' + res.data.total + ' ticket',
            },
          },
          chart: { type: this.chart_type, height: 300, width: 600 },
          title: { text: 'Tổng ' + res.data.total + ' ticket' },
          series: [
            {
              name: 'Ticket',
              colorByPoint: true,
              data: data,
            },
          ],
        };
      });
  }

  loadContactSummary() {
    this.reportService
      .reportContactSummary({
        filter: this.analytic_contact_type,
        from: this.modelFilter.from,
        to: this.modelFilter.to,
      })
      .subscribe(res => {
        const data = _.map(res.data.contacts, e => {
          if (this.chart_contact_type == 'pie') {
            return {
              name: e.title + ': ' + e.count,
              y: e.count,
            };
          } else {
            return [e.title, e.count];
          }
        });
        this.options_contact = {
          xAxis: {
            type: 'category',
            labels: {
              rotation: -45,
              style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif',
              },
            },
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Tổng ' + res.data.total + ' khách hàng',
            },
          },
          chart: { type: this.chart_contact_type, height: 300, width: 600 },
          title: { text: 'Tổng ' + res.data.total + ' khách hàng' },
          series: [
            {
              name: 'Khách hàng',
              colorByPoint: true,
              data: data,
            },
          ],
        };
      });
  }

  submitFilter() {
    console.log($('#inputStart').val());
    if (this.modelFilter.from) {
      this.modelFilter.from = moment(this.modelFilter.from).format('YYYY-MM-DD HH:mm');
    }
    if (this.modelFilter.to) {
      this.modelFilter.to = moment(this.modelFilter.to).format('YYYY-MM-DD HH:mm');
    }
    this.loadTicketSummary();
    this.loadContactSummary();
  }

  changeChartType(type) {
    this.chart_type = type;
    this.loadTicketSummary();
  }
  changeChartContactType(type) {
    this.chart_contact_type = type;
    this.loadContactSummary();
  }

  public changedSummayType(e: any): void {
    this.analytic_type = e.value;
    this.loadTicketSummary();
  }

  public changedSummayContactType(e: any): void {
    this.analytic_contact_type = e.value;
    this.loadContactSummary();
  }

  changeLayout(type) {
    this.layout = type;
    $('.3csoft-datepicker').datepicker({ format: 'yyyy-mm-dd h:m' });
    $('.3csoft-datepicker').datepicker({ format: 'yyyy-mm-dd h:m' });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/report/summary/summary.component.ts